import { getZoomLevels } from '../effects/useContextZoomEffect';

const MIN_ZOOM_LEVEL_LABEL_SCALE = 0.18;

// Zoom transform class constants
export const ZOOM_TRANSFORM_CLASSES = {
  NODE: 'zoom-transform-node',
  TARGET: 'zoom-transform-target',
} as const;

// Helper function to create the suffix class name
export const createZoomTransformNodeClass = (zoomTransformSuffix: string): string => {
  return `${ZOOM_TRANSFORM_CLASSES.NODE}-${zoomTransformSuffix}`;
};

export const getZoomTransformStyle = (zoomLevel: number, zoomTransformSuffix: string) => {
  const { isZoomHigherThan0_75 } = getZoomLevels(zoomLevel);

  if (!isZoomHigherThan0_75) {
    const _zoomLevel =
      zoomLevel < MIN_ZOOM_LEVEL_LABEL_SCALE ? MIN_ZOOM_LEVEL_LABEL_SCALE : zoomLevel;
    const transform = `scale(${1 / _zoomLevel})`;

    return {
      [`.${ZOOM_TRANSFORM_CLASSES.NODE}.${createZoomTransformNodeClass(zoomTransformSuffix)} .${ZOOM_TRANSFORM_CLASSES.TARGET}`]:
        {
          transform,
        },
    };
  }

  return {
    [`.${ZOOM_TRANSFORM_CLASSES.NODE}.${createZoomTransformNodeClass(zoomTransformSuffix)} .${ZOOM_TRANSFORM_CLASSES.TARGET}`]:
      {
        transform: 'scale(1)',
      },
  };
};
